var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('button',{staticClass:"btn btn-primary mr-1 rounded-pill"},[_vm._v("میزان اعتبار: "+_vm._s(_vm.charge))])])
}
var staticRenderFns = []

export { render, staticRenderFns }